import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchRoutingModule } from './search-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchEffects } from './core/search.effects';
import { reducer } from './core/search.reducer';
import { SearchWrapperComponent } from './search-wrapper/search-wrapper.component';
import { SearchResultsListComponent } from './components/search-results-list/search-results-list.component';
import { SearchResultCardComponent } from './components/search-result-card/search-result-card.component';
import { DailyReportCardComponent } from './components/daily-report-card/daily-report-card.component';
import { IssueCardComponent } from './components/issue-card/issue-card.component';
import { SearchDetailsComponent } from './components/search-details/search-details.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { SearchMapWrapperComponent } from './components/maps/search-map-wrapper/search-map-wrapper.component';
import { ProjectLocationMapComponent } from './components/maps/project-location-map/project-location-map.component';
import { ProjectModule } from '../project/project.module';


@NgModule({
  declarations: [
    SearchWrapperComponent,
    SearchResultsListComponent,
    SearchResultCardComponent,
    DailyReportCardComponent,
    IssueCardComponent,
    SearchDetailsComponent,
    DateRangeFilterComponent,
    SearchMapWrapperComponent,
    ProjectLocationMapComponent,
  ],
  imports: [
    CommonModule,
    SearchRoutingModule,
    SharedModule,
    StoreModule.forFeature('sitenotes.search', reducer),
    EffectsModule.forFeature([SearchEffects]),
    FormsModule,
    ReactiveFormsModule,
    ProjectModule,
  ],
})
export class SearchModule {
}
